import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-[#0F392B]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="font-body text-sm">Back to Home</span>
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white">
            Terms & Conditions
          </h1>
          <p className="font-body text-white/70 mt-4">
            Last updated: December 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-[#F9F9F7]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg prose prose-lg max-w-none">
            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              1. Acceptance of Terms
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              By accessing and using the services of Espady Multi-Service Co.,
              you accept and agree to be bound by these Terms and Conditions. If
              you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              2. Services Provided
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-4">
              Espady Multi-Service Co. provides the following services:
            </p>
            <ul className="font-body text-[#4A5568] space-y-2 mb-6 list-disc pl-6">
              <li>Tax preparation and filing services</li>
              <li>Immigration form assistance and notary services</li>
              <li>Recruitment and staffing services</li>
              <li>Credit repair consultation</li>
              <li>Business development and documentation services</li>
              <li>Website design and AI automation services</li>
              <li>Travel planning and booking services</li>
              <li>Administrative services (fax, print, scan, money transfers)</li>
              <li>Bookkeeping services</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              3. Client Responsibilities
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-4">
              As a client, you agree to:
            </p>
            <ul className="font-body text-[#4A5568] space-y-2 mb-6 list-disc pl-6">
              <li>Provide accurate and complete information</li>
              <li>Review all documents before signing or submission</li>
              <li>Pay for services as agreed upon</li>
              <li>Notify us promptly of any changes to your information</li>
              <li>Keep copies of all documents provided to us</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              4. Fees and Payment
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Service fees will be communicated before work begins. Payment is
              due upon completion of services unless otherwise agreed. We accept
              various payment methods including cash, check, and credit cards.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              5. Cancellation Policy
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Appointments may be cancelled or rescheduled with at least 24
              hours notice. Cancellations with less than 24 hours notice may be
              subject to a cancellation fee.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              6. Confidentiality
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              We maintain strict confidentiality of all client information.
              Your personal and financial information will only be shared as
              necessary to provide our services or as required by law.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              7. Limitation of Liability
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Espady Multi-Service Co. shall not be liable for any indirect,
              incidental, special, or consequential damages arising from the
              use of our services. Our liability is limited to the fees paid
              for the specific service in question.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              8. Changes to Terms
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              We reserve the right to modify these terms at any time. Changes
              will be effective immediately upon posting on our website.
              Continued use of our services constitutes acceptance of modified
              terms.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              9. Contact Information
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed">
              For questions about these Terms and Conditions, please contact us:
            </p>
            <div className="font-body text-[#4A5568] mt-4">
              <p>Espady Multi-Service Co.</p>
              <p>1368-B S Military Trail, Suite R</p>
              <p>West Palm Beach, FL 33415</p>
              <p>Phone: 786-991-8919</p>
              <p>Email: espadywisellc@gmail.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
